/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivAnalyticsCountGen,
  MrfiktivArchiveFleetDtoGen,
  MrfiktivCreateFleetDtoGen,
  MrfiktivFleetControllerFindAllParamsGen,
  MrfiktivFleetOpenReportViewModelGen,
  MrfiktivFleetViewModelGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateFleetDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Fleet<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerEnsureIndexesAsAdmin
   * @summary (ADMIN) Recreate indexes on fleet collection
   * @request PATCH:/partner/{partnerId}/fleet/ensureIndexesAsAdmin
   * @secure
   * @response `200` `void`
   */
  fleetControllerEnsureIndexesAsAdmin = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partner/${partnerId}/fleet/ensureIndexesAsAdmin`,
      method: "PATCH",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerCreate
   * @summary (Fleet - CREATE) Create a fleet
   * @request POST:/partner/{partnerId}/fleet
   * @secure
   * @response `201` `MrfiktivFleetViewModelGen` The created fleet
   */
  fleetControllerCreate = (partnerId: string, data: MrfiktivCreateFleetDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen, any>({
      path: `/partner/${partnerId}/fleet`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerFindAll
   * @summary (Fleet - READ) Get all fleet
   * @request GET:/partner/{partnerId}/fleet
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivFleetViewModelGen)[] })`
   */
  fleetControllerFindAll = (
    { partnerId, ...query }: MrfiktivFleetControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivFleetViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerFindMany
   * @summary (Fleet - READ) Get many fleet
   * @request POST:/partner/{partnerId}/fleet/getByIds
   * @secure
   * @response `200` `(MrfiktivFleetViewModelGen)[]` The fleets
   */
  fleetControllerFindMany = (partnerId: string, data: MrfiktivMultipleIdsDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/getByIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerFindOne
   * @summary (Fleet - READ) Get a fleet
   * @request GET:/partner/{partnerId}/fleet/{fleetId}
   * @secure
   * @response `200` `MrfiktivFleetViewModelGen` The fleet
   */
  fleetControllerFindOne = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerUpdate
   * @summary (Fleet - UPDATE) Updates a fleet
   * @request PATCH:/partner/{partnerId}/fleet/{fleetId}
   * @secure
   * @response `201` `MrfiktivFleetViewModelGen` The updated fleet
   */
  fleetControllerUpdate = (
    partnerId: string,
    fleetId: string,
    data: MrfiktivUpdateFleetDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivFleetViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerFindOpenReports
   * @summary (Report - READ) Open damages of a fleet and its sub fleets, which block archiving
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/open-reports
   * @secure
   * @response `200` `(MrfiktivFleetOpenReportViewModelGen)[]` The open reports
   */
  fleetControllerFindOpenReports = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetOpenReportViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/open-reports`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerCountActiveVehicles
   * @summary (Vehicle - READ) Count the active vehicles of a fleet and its sub fleets
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/active-vehicle-count
   * @secure
   * @response `200` `MrfiktivAnalyticsCountGen` The number of active vehicles
   */
  fleetControllerCountActiveVehicles = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivAnalyticsCountGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/active-vehicle-count`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerArchive
   * @summary (Fleet - DELETE) Archives a fleet including its sub fleets
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/archive
   * @secure
   * @response `201` `MrfiktivFleetViewModelGen` The archived fleet
   */
  fleetControllerArchive = (
    partnerId: string,
    fleetId: string,
    data: MrfiktivArchiveFleetDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivFleetViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/archive`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerRestoreArchived
   * @summary (ADMIN) Restores an archived fleet
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/restore
   * @secure
   * @response `201` `MrfiktivFleetViewModelGen` The restored fleet
   */
  fleetControllerRestoreArchived = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/restore`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerDelete
   * @summary (Fleet - DELETE) Deletes a fleet
   * @request DELETE:/partner/{partnerId}/fleet/{fleetId}
   * @secure
   * @response `200` `MrfiktivFleetViewModelGen` The deleted fleet
   */
  fleetControllerDelete = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerFindAllRelatedForFleet
   * @summary (Fleet - READ) Get all related nodes of a fleet
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/all
   * @secure
   * @response `200` `(MrfiktivFleetViewModelGen)[]` The fleet
   */
  fleetControllerFindAllRelatedForFleet = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerFindAllAncestorsForFleet
   * @summary (Fleet - READ) Get all ancestors nodes of a given fleet
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/ancestors
   * @secure
   * @response `200` `(MrfiktivFleetViewModelGen)[]` The fleet
   */
  fleetControllerFindAllAncestorsForFleet = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/ancestors`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet
   * @name FleetControllerFindAllChildrenForFleet
   * @summary (Fleet - READ) Get all children nodes of a given fleet
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/children
   * @secure
   * @response `200` `(MrfiktivFleetViewModelGen)[]` The fleet
   */
  fleetControllerFindAllChildrenForFleet = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/children`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
